export const OWN_FOLLOWINGS = "OWN_FOLLOWINGS";

export const ADD_NEW_FOLLOWING = "ADD_NEW_FOLLOWING";
export const DELETE_FOLLOWING = "DELETE_FOLLOWING";



// WEBPACK FOOTER //
// ./src/actions/social.js